import * as React from "react";
import { Tag } from "@chakra-ui/react";
import { capitalize } from "lodash-es";
import { IoAddOutline } from "react-icons/io5";
import { Wrapper, Button, Link, PageHeader, Table } from "components";
import { useQueryParams } from "duck";
import {
  Fragments,
  LicensePeriodEnum,
  useDeleteLicenseMutation,
  useGetLicensesQuery
} from "requests";

const List: React.FC = () => {
  const [params] = useQueryParams();

  const { data, loading, refetch } = useGetLicensesQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      page: params?.pagination?.page || 1,
      perPage: 15,
      filter: { exists: { deletedAt: false } }
    }
  });

  const [deleteLicense] = useDeleteLicenseMutation({ ignoreResults: true });

  return (
    <>
      <PageHeader
        title="License Management"
        actions={
          <Button to="./create" as={Link} leftIcon={<IoAddOutline />}>
            New License
          </Button>
        }
      />
      <Wrapper mt={6} withPadding={false}>
        <Table
          data={data?.licenses?.collection || []}
          loading={loading}
          totalCount={data?.licenses?.paginationInfo?.totalCount || 0}
          perPage={15}
        >
          <Table.Column dataKey="_id" label="License ID" />
          <Table.Column dataKey="name" label="License Name" />
          <Table.Column<LicensePeriodEnum>
            dataKey="period"
            label="License Period"
            render={({ value }) => capitalize(value)}
          />
          <Table.Column dataKey="price" label="License Price" />
          <Table.Column dataKey="maxNumberOfUsers" label="Users" />
          <Table.Column<boolean>
            dataKey="active"
            label="Status"
            render={({ value }) =>
              value ? (
                <Tag colorScheme="green">Active</Tag>
              ) : (
                <Tag colorScheme="red">Inactive</Tag>
              )
            }
          />
          <Table.Column<number, Fragments.License>
            w="108px"
            dataKey="_id"
            label="Actions"
            render={({ value, record }) => (
              <Table.Actions
                editURL={`/license-management/${value}/edit`}
                deleteTitle={`Delete License ${record.name}`}
                onDelete={toast =>
                  deleteLicense({ variables: { id: value } })
                    .then(() => refetch())
                    .then(() => {
                      toast("License is deleted successfully.");
                    })
                }
              />
            )}
          />
        </Table>
      </Wrapper>
    </>
  );
};

export default List;
